export { default } from './HotspotControl';
